export default [
    // ['KEY', 'VALUE']
];